import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const pre_ = ''

const nescRouter = new Router({
  mode: 'history', // 去掉#号
  routes: [
    {
      path: pre_ + '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: pre_ + '/about/:type',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: pre_ + '/productGroup/:type',
      name: 'productGroup',
      component: () => import('./views/Productions.vue')
    },
    {
      path: pre_ + '/solutions/:type',
      name: 'solutions',
      component: () => import('./views/Solutions.vue')
    },
    {
      path: '/technology/:type',
      name: 'technology',
      component: () => import('./views/Technology.vue')
    },
    {
      path: pre_ + '/newsDetail/:id/:time',
      name: 'newsDetail',
      component: () => import('./views/NewsDetail.vue')
    },
    {
      path: '/talentRecruitment',
      name: 'talentRecruitment',
      component: () => import('./views/TalentRecruitment.vue')
    },
    {
      path: pre_ + '/recruitmentDetail/:id/:time',
      name: 'recruitmentDetail',
      component: () => import('./views/RecruitmentDetail.vue')
    },
    {
      path: '/channelCooperation',
      name: 'channelCooperation',
      component: () => import('./views/ChannelCooperation.vue')
    },
    {
      path: '/bidAnnouncement',
      name: 'bidAnnouncement',
      component: () => import('./views/Bid.vue')
    },
    {
      path: '*',
      redirect: '/home',
      hidden: true
    }
  ]
})

export default nescRouter
